import { render, staticRenderFns } from "./AddMemberTabs.vue?vue&type=template&id=cd80dc02"
import script from "./AddMemberTabs.vue?vue&type=script&lang=js"
export * from "./AddMemberTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports